import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { UserIcon } from "lucide-react";
import { UserOptions } from "./UserOptions.js";
import { Avatar, AvatarFallback, AvatarImage } from "@nxt-shared/ui/components/Avatar";
import { Button } from "@nxt-shared/ui/components/Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@nxt-shared/ui/components/DropdownMenu";
import { globalComponents } from "../../i18n.js";
import { track } from "../../usage/track.js";
function initialsOf(name) {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0)
        return "";
    const first = words[0]?.charAt(0) ?? "";
    const last = words.length > 1 ? (words[words.length - 1]?.charAt(0) ?? "") : "";
    return `${first}${last}`.toUpperCase();
}
// Photo with a thin inner hairline (keeps light photos readable on the bar, no outer ring);
// fallback initials on the secondary-dark surface, or a person icon when no name is known.
function UserAvatar({ userName, userPic }) {
    const initials = initialsOf(userName);
    const [imageLoaded, setImageLoaded] = useState(false);
    return (_jsxs(Avatar, { size: "sm", className: "bg-secondary-darkest text-secondary-foreground", children: [_jsx(AvatarImage, { src: userPic, onLoadingStatusChange: (status) => setImageLoaded(status === "loaded") }), _jsx(AvatarFallback, { className: "bg-secondary-darkest text-sm font-bold text-secondary-foreground", children: initials || _jsx(UserIcon, { className: "size-4" }) }), userPic && imageLoaded && (_jsx("span", { "aria-hidden": true, "data-slot": "avatar-hairline", className: "pointer-events-none absolute inset-0 rounded-full ring-1 ring-foreground/20 ring-inset" }))] }));
}
function onUserMenuOpenChange(open) {
    if (open)
        track("user_menu.opened");
}
export function UserMenu({ userName, userPic, isTickarooStaff, hideLanguageChoice }) {
    const t = globalComponents.useT();
    return (_jsxs(DropdownMenu, { onOpenChange: onUserMenuOpenChange, children: [_jsx(DropdownMenuTrigger, { render: (props) => (_jsx(Button, { ...props, variant: "topbar", size: "icon-lg", className: "rounded-full", icon: false, "aria-label": t("topBar.userMenu"), children: _jsx(UserAvatar, { userName: userName, userPic: userPic }) })) }), _jsx(DropdownMenuContent, { align: "end", children: _jsx(UserOptions, { avatar: _jsx(UserAvatar, { userName: userName, userPic: userPic }), userName: userName, isTickarooStaff: isTickarooStaff, hideLanguageChoice: hideLanguageChoice }) })] }));
}
//# sourceMappingURL=UserMenu.js.map